import styled, { keyframes } from "styled-components";
// @ts-ignore
import { fadeInDown } from "react-animations";

export const FadeInDownAnimation = keyframes`${fadeInDown}`;
export const FadeInDownDiv = styled.div`
  animation: 1.2s ${FadeInDownAnimation};
`;
